import {
  GetProductivityDataOutput,
  GetProductivityReportOutput,
  GetWeeklySpprSummariesOutput,
  GetUnknownIdleTimeMetricsOutput,
} from '../types/backendService';
import moment from 'moment';
import {getPerformanceWeekStart} from "src/util/date_time_utils";

export const getDailyProductivityDataForWeekStub = (): GetProductivityDataOutput => {
  return {
    productivities: [
      {
        configuredRate: 78,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1658923200,
        percentToCurve: 104.04853943000934,
        percentToGoal: 104.04853943000934,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 18586000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 419,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 152,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1658923200,
        percentToCurve: 109.86233300247223,
        percentToGoal: 109.86233300247223,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 8537000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 396,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 82,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1658923200,
        percentToCurve: 180.13753744412963,
        percentToGoal: 180.13753744412963,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 3607000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 148,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 78,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1659009600,
        percentToCurve: 129.56740229467502,
        percentToGoal: 129.56740229467502,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 7623000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 214,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 152,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1659009600,
        percentToCurve: 126.41898864809079,
        percentToGoal: 126.41898864809079,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 10098000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 539,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 82,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1659009600,
        percentToCurve: 121.1046454636998,
        percentToGoal: 121.1046454636998,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 10948000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 302,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 121,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1659009600,
        percentToCurve: 127.97083143482841,
        percentToGoal: 127.97083143482841,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 6532997,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 281,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 78,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1659096000,
        percentToCurve: 119.45818963362824,
        percentToGoal: 119.45818963362824,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 9234000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 239,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 152,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1659096000,
        percentToCurve: 111.98051497565159,
        percentToGoal: 111.98051497565159,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 14212999,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 672,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 82,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1659096000,
        percentToCurve: 122.83664540204812,
        percentToGoal: 122.83664540204812,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 5647000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 158,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 121,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1659096000,
        percentToCurve: 124.68497895166628,
        percentToGoal: 124.68497895166628,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 2935000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 123,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 78,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1659355200,
        percentToCurve: 132.2038877735886,
        percentToGoal: 132.2038877735886,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 12568000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 360,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 152,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1659355200,
        percentToCurve: 141.6586545916943,
        percentToGoal: 141.6586545916943,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 10182000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 609,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 82,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1659355200,
        percentToCurve: 126.91622941283616,
        percentToGoal: 126.91622941283616,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 8302000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 240,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 121,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1659355200,
        percentToCurve: 91.37988734918916,
        percentToGoal: 91.37988734918916,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 5828000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 179,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 78,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1659441600,
        percentToCurve: 102.05143283649605,
        percentToGoal: 102.05143283649605,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 17005000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 376,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 152,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1659441600,
        percentToCurve: 101.21459549597618,
        percentToGoal: 101.21459549597618,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 4913999,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 210,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 82,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1659441600,
        percentToCurve: 125.74348329408008,
        percentToGoal: 125.74348329408008,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 3666000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 105,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 121,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: 1659441600,
        percentToCurve: 147.49281420642592,
        percentToGoal: 147.49281420642592,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 5164000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 256,
        warehouseId: 'PHX6',
      },
    ],
  };
};

export const getSpprSummariesStub = (): GetWeeklySpprSummariesOutput => {
  const now = moment().startOf('hour');
  const lastSpprPeriodEnd = now
    .subtract(3, 'days')
    .startOf('week')
    .add(3, 'days');

  return {
    summaries: [
      {
        employeeStanding: 'MetExpectations',
        endTime: lastSpprPeriodEnd
          .clone()
          .subtract(13, 'weeks')
          .unix(),
        metricTime: lastSpprPeriodEnd
          .clone()
          .subtract(14, 'weeks')
          .unix(),
        percentToCurve: 148.90997946769951,
        percentToGoal: 148.90997946769951,
        rank: 413,
        rankPercentile: 45.70588302612305,
        timeWorked: 119935995,
        totalPopulation: 1190,
        units: 5630,
        warehouseId: 'PHX6',
      },
      {
        employeeStanding: 'MetExpectations',
        endTime: lastSpprPeriodEnd
          .clone()
          .subtract(12, 'weeks')
          .unix(),
        metricTime: lastSpprPeriodEnd
          .clone()
          .subtract(13, 'weeks')
          .unix(),
        percentToCurve: 101.7258313455872,
        percentToGoal: 101.7258313455872,
        rank: 845,
        rankPercentile: 52.73175048828125,
        timeWorked: 42762000,
        totalPopulation: 1178,
        units: 1740,
        warehouseId: 'PHX6',
      },
      {
        employeeStanding: 'MetExpectations',
        endTime: lastSpprPeriodEnd
          .clone()
          .subtract(11, 'weeks')
          .unix(),
        metricTime: lastSpprPeriodEnd
          .clone()
          .subtract(12, 'weeks')
          .unix(),
        percentToCurve: 130.10313854990613,
        percentToGoal: 130.10313854990613,
        rank: 704,
        rankPercentile: 56.45549392700195,
        timeWorked: 18218000,
        totalPopulation: 1247,
        units: 902,
        warehouseId: 'PHX6',
      },
      {
        employeeStanding: 'MetExpectations',
        endTime: lastSpprPeriodEnd
          .clone()
          .subtract(10, 'weeks')
          .unix(),
        metricTime: lastSpprPeriodEnd
          .clone()
          .subtract(11, 'weeks')
          .unix(),
        percentToCurve: 147.0472394417597,
        percentToGoal: 147.0472394417597,
        rank: 471,
        rankPercentile: 38.79736328125,
        timeWorked: 25106999,
        totalPopulation: 1214,
        units: 1446,
        warehouseId: 'PHX6',
      },
      {
        employeeStanding: 'MetExpectations',
        endTime: lastSpprPeriodEnd
          .clone()
          .subtract(9, 'weeks')
          .unix(),
        metricTime: lastSpprPeriodEnd
          .clone()
          .subtract(10, 'weeks')
          .unix(),
        percentToCurve: 148.90997946769951,
        percentToGoal: 148.90997946769951,
        rank: 413,
        rankPercentile: 34.70588302612305,
        timeWorked: 119935995,
        totalPopulation: 1190,
        units: 5630,
        warehouseId: 'PHX6',
      },
      {
        employeeStanding: 'MetExpectations',
        endTime: lastSpprPeriodEnd
          .clone()
          .subtract(8, 'weeks')
          .unix(),
        metricTime: lastSpprPeriodEnd
          .clone()
          .subtract(9, 'weeks')
          .unix(),
        percentToCurve: 101.7258313455872,
        percentToGoal: 101.7258313455872,
        rank: 845,
        rankPercentile: 71.73175048828125,
        timeWorked: 42762000,
        totalPopulation: 1178,
        units: 1740,
        warehouseId: 'PHX6',
      },
      {
        employeeStanding: 'MetExpectations',
        endTime: lastSpprPeriodEnd
          .clone()
          .subtract(7, 'weeks')
          .unix(),
        metricTime: lastSpprPeriodEnd
          .clone()
          .subtract(8, 'weeks')
          .unix(),
        percentToCurve: 150.97918998857165,
        percentToGoal: 150.97918998857165,
        rank: 431,
        rankPercentile: 35.38587951660156,
        timeWorked: 107234999,
        totalPopulation: 1218,
        units: 5309,
        warehouseId: 'PHX6',
      },
      {
        employeeStanding: 'MetExpectations',
        endTime: lastSpprPeriodEnd
          .clone()
          .subtract(6, 'weeks')
          .unix(),
        metricTime: lastSpprPeriodEnd
          .clone()
          .subtract(7, 'weeks')
          .unix(),
        percentToCurve: 142.426247049575,
        percentToGoal: 142.426247049575,
        rank: 374,
        rankPercentile: 29.943954467773438,
        timeWorked: 93893998,
        totalPopulation: 1249,
        units: 4069,
        warehouseId: 'PHX6',
      },
      {
        employeeStanding: 'MetExpectations',
        endTime: lastSpprPeriodEnd
          .clone()
          .subtract(5, 'weeks')
          .unix(),
        metricTime: lastSpprPeriodEnd
          .clone()
          .subtract(6, 'weeks')
          .unix(),
        percentToCurve: 144.6386849672148,
        percentToGoal: 144.6386849672148,
        rank: 349,
        rankPercentile: 28.397069931030273,
        timeWorked: 34796000,
        totalPopulation: 1229,
        units: 2111,
        warehouseId: 'PHX6',
      },
      {
        employeeStanding: 'MetExpectations',
        endTime: lastSpprPeriodEnd
          .clone()
          .subtract(4, 'weeks')
          .unix(),
        metricTime: lastSpprPeriodEnd
          .clone()
          .subtract(5, 'weeks')
          .unix(),
        percentToCurve: 120.74941819419217,
        percentToGoal: 120.74941819419217,
        rank: 749,
        rankPercentile: 61.092987060546875,
        timeWorked: 110933995,
        totalPopulation: 1226,
        units: 4261,
        warehouseId: 'PHX6',
      },
      {
        employeeStanding: 'MetExpectations',
        endTime: lastSpprPeriodEnd
          .clone()
          .subtract(3, 'weeks')
          .unix(),
        metricTime: lastSpprPeriodEnd
          .clone()
          .subtract(4, 'weeks')
          .unix(),
        percentToCurve: 144.29265183214682,
        percentToGoal: 144.29265183214682,
        rank: 520,
        rankPercentile: 38.95130920410156,
        timeWorked: 173170999,
        totalPopulation: 1335,
        units: 7975,
        warehouseId: 'PHX6',
      },
      {
        employeeStanding: 'MetExpectations',
        endTime: lastSpprPeriodEnd
          .clone()
          .subtract(2, 'weeks')
          .unix(),
        metricTime: lastSpprPeriodEnd
          .clone()
          .subtract(3, 'weeks')
          .unix(),
        percentToCurve: 134.18527068930547,
        percentToGoal: 134.18527068930547,
        rank: 569,
        rankPercentile: 41.59356689453125,
        timeWorked: 92047999,
        totalPopulation: 1368,
        units: 4045,
        warehouseId: 'PHX6',
      },
      {
        employeeStanding: 'MetExpectations',
        endTime: lastSpprPeriodEnd
          .clone()
          .subtract(1, 'week')
          .unix(),
        metricTime: lastSpprPeriodEnd
          .clone()
          .subtract(2, 'weeks')
          .unix(),
        percentToCurve: 145.08706781978412,
        percentToGoal: 145.08706781978412,
        rank: 423,
        rankPercentile: 33.921409606933594,
        timeWorked: 20977999,
        totalPopulation: 1247,
        units: 651,
        warehouseId: 'PHX6',
      },
      {
        employeeStanding: 'MetExpectations',
        endTime: lastSpprPeriodEnd.clone().unix(),
        metricTime: lastSpprPeriodEnd
          .clone()
          .subtract(1, 'week')
          .unix(),
        percentToCurve: 119.97476059319219,
        percentToGoal: 119.97476059319219,
        rank: 615,
        rankPercentile: 48.19749069213867,
        timeWorked: 165589995,
        totalPopulation: 1276,
        units: 5826,
        warehouseId: 'PHX6',
      },
    ],
  };
};

export const getHourlyProductivityDataStub = (): GetProductivityDataOutput => {
  const now = moment().startOf('hour');

  return {
    productivities: [
      {
        configuredRate: 79,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(24, 'hours')
          .unix(),
        percentToCurve: 107.81455895859122,
        percentToGoal: 107.81455895859122,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 1902000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 45,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 152,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(24, 'hours')
          .unix(),
        percentToCurve: 108.92502482621649,
        percentToGoal: 108.92502482621649,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 1696000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 78,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 79,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(23, 'hours')
          .unix(),
        percentToCurve: 104.19046748617649,
        percentToGoal: 104.19046748617649,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 831000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 19,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 152,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(23, 'hours')
          .unix(),
        percentToCurve: 105.31758558754693,
        percentToGoal: 105.31758558754693,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 967000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 43,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 79,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(22, 'hours')
          .unix(),
        percentToCurve: 224.19026017869666,
        percentToGoal: 224.19026017869666,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 1931000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 95,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 152,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(22, 'hours')
          .unix(),
        percentToCurve: 226.3020115734362,
        percentToGoal: 226.3020115734362,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 1528000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 146,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 81,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(22, 'hours')
          .unix(),
        percentToCurve: 111.11111111111111,
        percentToGoal: 111.11111111111111,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 80000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 2,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 79,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(21, 'hours')
          .unix(),
        percentToCurve: 105.31873902929803,
        percentToGoal: 105.31873902929803,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 1774000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 41,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 152,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(21, 'hours')
          .unix(),
        percentToCurve: 106.44589000591367,
        percentToGoal: 106.44589000591367,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 712000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 32,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 81,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(21, 'hours')
          .unix(),
        percentToCurve: 78.22222222222223,
        percentToGoal: 78.22222222222223,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 625000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 11,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 123,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(21, 'hours')
          .unix(),
        percentToCurve: 78.28967178560674,
        percentToGoal: 78.28967178560674,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 486000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 13,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 81,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(4, 'hours')
          .unix(),
        percentToCurve: 41.44004144004144,
        percentToGoal: 41.44004144004144,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 1287000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 12,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 123,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(4, 'hours')
          .unix(),
        percentToCurve: 41.61368627904289,
        percentToGoal: 41.61368627904289,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 211000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 3,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 79,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(3, 'hours')
          .unix(),
        percentToCurve: 107.6808522824904,
        percentToGoal: 107.6808522824904,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 1989000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 47,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 152,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(3, 'hours')
          .unix(),
        percentToCurve: 105.98279415131991,
        percentToGoal: 105.98279415131991,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 1609000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 72,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 79,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(2, 'hours')
          .unix(),
        percentToCurve: 143.1506395387368,
        percentToGoal: 143.1506395387368,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 955000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 30,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 152,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(2, 'hours')
          .unix(),
        percentToCurve: 140.69828035435123,
        percentToGoal: 140.69828035435123,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 505000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 30,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 81,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(2, 'hours')
          .unix(),
        percentToCurve: 181.93632228719946,
        percentToGoal: 181.93632228719946,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 1197000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 49,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 123,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(2, 'hours')
          .unix(),
        percentToCurve: 186.8188894654904,
        percentToGoal: 186.8188894654904,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 940000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 60,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 79,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(1, 'hours')
          .unix(),
        percentToCurve: 223.29940958900966,
        percentToGoal: 223.29940958900966,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 551000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 27,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 152,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(1, 'hours')
          .unix(),
        percentToCurve: 218.52742577004904,
        percentToGoal: 218.52742577004904,
        processAttributes: {
          functionName: 'Each Transfer In',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Each Transfer In',
        timeWorked: 1138000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 105,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 81,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(1, 'hours')
          .unix(),
        percentToCurve: 146.6813348001467,
        percentToGoal: 146.6813348001467,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Medium',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 303000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 10,
        warehouseId: 'PHX6',
      },
      {
        configuredRate: 123,
        learningCurveFamily: 'Stow',
        learningCurveId: 'Level 5',
        metricTime: now
          .clone()
          .subtract(1, 'hours')
          .unix(),
        percentToCurve: 149.62593516209478,
        percentToGoal: 149.62593516209478,
        processAttributes: {
          functionName: 'Each Stow to Prime',
          jobAction: 'EachStowed',
          sizeCategory: 'Small',
          unitType: 'EACH',
        },
        processName: 'Stow to Prime',
        timeWorked: 1604000,
        unconfiguredTimeWorked: 0,
        unconfiguredUnits: 0,
        units: 82,
        warehouseId: 'PHX6',
      },
    ],
  };
};

export const getProductivityReportDataStub = (): GetProductivityReportOutput => {
  return {
    productivityReportItems: [
      {
        guardrailRate: 70.0,
        percentToPeers: 60.52848815917969,
        periodStart: getPerformanceWeekStart().unix(),
        secondsWorked: 31741,
        unitsPerHour: 31.983869443306762,
        unitsProcessed: 282,
        workItem: 'PHX6 / Each Transfer In / Each Transfer In / EachStowed / EACH / Medium',
      },
      {
        guardrailRate: 58.0,
        percentToPeers: 60.52848815917969,
        periodStart: getPerformanceWeekStart().unix(),
        secondsWorked: 34947,
        unitsPerHour: 63.96932768597137,
        unitsProcessed: 621,
        workItem: 'PHX6 / Pick / RF Pick / ItemPicked / EACH / Medium',
      },
      {
        guardrailRate: 77.0,
        percentToPeers: 60.52848815917969,
        periodStart: getPerformanceWeekStart().unix(),
        secondsWorked: 28201,
        unitsPerHour: 95.99319537597317,
        unitsProcessed: 752,
        workItem: 'PHX6 / Pick / RF Pick / ItemPicked / EACH / Small',
      },
      {
        guardrailRate: 57.0,
        percentToPeers: 10.778443336486816,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 1 }).unix(),
        secondsWorked: 35051,
        unitsPerHour: 83.70421327468371,
        unitsProcessed: 815,
        workItem: 'PHX6 / Pick / RF Pick / ItemPicked / EACH / Medium',
      },
      {
        guardrailRate: 77.0,
        percentToPeers: 10.778443336486816,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 1 }).unix(),
        secondsWorked: 38213,
        unitsPerHour: 116.25363096328475,
        unitsProcessed: 1234,
        workItem: 'PHX6 / Pick / RF Pick / ItemPicked / EACH / Small',
      },
      {
        guardrailRate: 148.0,
        percentToPeers: 10.778443336486816,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 3 }).unix(),
        secondsWorked: 20491,
        unitsPerHour: 69.217262269887,
        unitsProcessed: 394,
        workItem: 'PHX6 / Stow to Prime / Each Stow to Prime / EachStowed / EACH / Small',
      },
      {
        guardrailRate: 66.0,
        percentToPeers: 69.03799438476562,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 4 }).unix(),
        secondsWorked: 73389,
        unitsPerHour: 67.10542451866083,
        unitsProcessed: 1368,
        workItem: 'PHX6 / Each Transfer In / Each Transfer In / EachStowed / EACH / Medium',
      },
      {
        guardrailRate: 65.0,
        percentToPeers: 9.474671363830566,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 5 }).unix(),
        secondsWorked: 18301,
        unitsPerHour: 51.14474618873286,
        unitsProcessed: 260,
        workItem: 'PHX6 / Stow to Prime / Each Stow to Prime / EachStowed / EACH / Medium',
      },
      {
        guardrailRate: 141.0,
        percentToPeers: 9.474671363830566,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 5 }).unix(),
        secondsWorked: 20236,
        unitsPerHour: 525.4929349949565,
        unitsProcessed: 2954,
        workItem: 'PHX6 / Transfer Out Pick / RF Pick Transship / ItemPicked / EACH / Small',
      },
      {
        guardrailRate: 63.0,
        percentToPeers: 90.52745056152344,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 10 }).unix(),
        secondsWorked: 35562,
        unitsPerHour: 53.85523873797874,
        unitsProcessed: 532,
        workItem: 'PHX6 / Each Transfer In / Each Transfer In / EachStowed / EACH / Medium',
      },
      {
        guardrailRate: 153.0,
        percentToPeers: 90.52745056152344,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 10 }).unix(),
        secondsWorked: 30026,
        unitsPerHour: 103.34699459466445,
        unitsProcessed: 862,
        workItem: 'PHX6 / Stow to Prime / Each Stow to Prime / EachStowed / EACH / Small',
      },
      {
        guardrailRate: 65.0,
        percentToPeers: 75.06596374511719,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 14 }).unix(),
        secondsWorked: 33087,
        unitsPerHour: 72.24589718016139,
        unitsProcessed: 664,
        workItem: 'PHX6 / Each Transfer In / Each Transfer In / EachStowed / EACH / Medium',
      },
      {
        guardrailRate: 51.0,
        percentToPeers: 30.169490814208984,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 14 }).unix(),
        secondsWorked: 39924,
        unitsPerHour: 60.324616771866545,
        unitsProcessed: 669,
        workItem: 'PHX6 / Pick / RF Pick / ItemPicked / EACH / Medium',
      },
      {
        guardrailRate: 74.0,
        percentToPeers: 30.169490814208984,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 15 }).unix(),
        secondsWorked: 32055,
        unitsPerHour: 92.76555919513336,
        unitsProcessed: 826,
        workItem: 'PHX6 / Pick / RF Pick / ItemPicked / EACH / Small',
      },
      {
        guardrailRate: 76.0,
        percentToPeers: 30.169490814208984,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 16 }).unix(),
        secondsWorked: 21012,
        unitsPerHour: 72.98339818049762,
        unitsProcessed: 426,
        workItem: 'PHX6 / Transfer Out Pick / RF Pick Transship / ItemPicked / EACH / Medium',
      },
      {
        guardrailRate: 75.0,
        percentToPeers: 64.38214111328125,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 17 }).unix(),
        secondsWorked: 23221,
        unitsPerHour: 74.5704319366091,
        unitsProcessed: 481,
        workItem: 'PHX6 / Transfer Out Pick / RF Pick Transship / ItemPicked / EACH / Medium',
      },
      {
        guardrailRate: 50.0,
        percentToPeers: 24.58333396911621,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 18 }).unix(),
        secondsWorked: 24526,
        unitsPerHour: 61.64635143500434,
        unitsProcessed: 420,
        workItem: 'PHX6 / Pick / RF Pick / ItemPicked / EACH / Medium',
      },
      {
        guardrailRate: 50.0,
        percentToPeers: 13.582343101501465,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 19 }).unix(),
        secondsWorked: 27268,
        unitsPerHour: 60.59628371397131,
        unitsProcessed: 459,
        workItem: 'PHX6 / Pick / RF Pick / ItemPicked / EACH / Medium',
      },
      {
        guardrailRate: 49.0,
        percentToPeers: 17.952754974365234,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 20 }).unix(),
        secondsWorked: 34090,
        unitsPerHour: 58.60784715073463,
        unitsProcessed: 555,
        workItem: 'PHX6 / Pick / RF Pick / ItemPicked / EACH / Medium',
      },
      {
        guardrailRate: 71.0,
        percentToPeers: 17.952754974365234,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 20 }).unix(),
        secondsWorked: 20373,
        unitsPerHour: 79.68981637181042,
        unitsProcessed: 451,
        workItem: 'PHX6 / Pick / RF Pick / ItemPicked / EACH / Small',
      },
      {
        guardrailRate: 70.0,
        percentToPeers: 17.952754974365234,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 22 }).unix(),
        secondsWorked: 33294,
        unitsPerHour: 179.37829041532632,
        unitsProcessed: 1659,
        workItem: 'PHX6 / Transfer Out Pick / RF Pick Transship / ItemPicked / EACH / Medium',
      },
    ],
  };
};

export const getUnknownIdleTimeMetricsStub = (): GetUnknownIdleTimeMetricsOutput => {
  return {
    unknownIdleTimeMetrics: [
      {
        timestamp: getPerformanceWeekStart().unix(),
        activeTime: 50000,
        totalIdleTime: 3000,
        feedback: 'FINAL_WRITTEN_WARNING received on 10/04/2023',
      },
      {
        timestamp: getPerformanceWeekStart().subtract({ days: 1 }).unix(),
        activeTime: 70000,
        totalIdleTime: 4100,
        feedback: 'SECOND_WRITTEN_WARNING received on 10/05/2023',
      },
      {
        timestamp: getPerformanceWeekStart().subtract({ weeks: 1 }).unix(),
        activeTime: 44000,
        totalIdleTime: 2100,
        feedback: 'FIRST_WRITTEN_WARNING received on 10/06/2023',
      },
      {
        timestamp: getPerformanceWeekStart().subtract({ days: 10 }).unix(),
        activeTime: 44000,
        totalIdleTime: 2100,
        feedback: 'DOCUMENTED_COACHING received on 10/06/2023',
      },
      {
        timestamp: getPerformanceWeekStart().subtract({ days: 15 }).unix(),
        activeTime: 52100,
        totalIdleTime: 1900,
        feedback: ''
      },
    ],
  };
};
